import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import moment from 'moment';
import { DateRangePicker, isInclusivelyAfterDay } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import styles from './DateRangePicker.less';

class DateRangePickerField extends Component {
  static propTypes = {
    startDateId: PropTypes.string,
    endDateId: PropTypes.string,
    label: PropTypes.string,
    field: PropTypes.shape({}).isRequired,
    form: PropTypes.shape({}).isRequired,
  }

  static defaultProps = {
    startDateId: 'startDateId',
    endDateId: 'endDateId',
    label: 'label',
  }

  state = {
    focusedInput: null,
  }

 handleFocusChange = (input) => {
   this.setState({ focusedInput: input });
 }

  handleDateChange = ({ startDate, endDate }) => {
    const { focusedInput } = this.state;
    const { field: { name }, form: { setFieldValue } } = this.props;

    if (focusedInput === 'startDate') {
      setFieldValue(name, { startDate, endDate: null });
    } else {
      setFieldValue(name, { startDate, endDate });
    }
  }

  render() {
    const {
      focusedInput,
    } = this.state;

    const {
      displayFormat,
      endTimeSize,
      endDatePlaceholderText,
      minimumNights,
      label,
      field: { name, value },
      form: { touched, errors },
      startDateId,
      endDateId,
    } = this.props;

    const { startDate, endDate } = value;
    const endTime = moment(moment().add(13, 'months').date(0));

    return (
      <Form.Field>
        <div className={styles.label}>{label}</div>
        <div className={styles.datePickerComponent}>
          <DateRangePicker
            startDateId={startDateId}
            endDateId={endDateId}
            startDate={startDate}
            endDate={endDate}
            onDatesChange={this.handleDateChange}
            focusedInput={focusedInput}
            onFocusChange={this.handleFocusChange}
            endDatePlaceholderText={endDatePlaceholderText}
            hideKeyboardShortcutsPanel
            isOutsideRange={
              day => (!isInclusivelyAfterDay(day, moment())
              || ((focusedInput === 'endDate') && isInclusivelyAfterDay(day, moment(startDate).add(endTimeSize, 'days')))
              || ((focusedInput === 'startDate') && isInclusivelyAfterDay(day, moment(startDate).add(endTime.diff(startDate, 'days', true), 'days'))))
            }
            noBorder
            minimumNights={minimumNights}
            displayFormat={() => displayFormat}
          />
        </div>
        {
          touched[name]
          && errors[name]
          && <div className={styles.errors}>{errors[name]}</div>
        }
      </Form.Field>
    );
  }
}

export default DateRangePickerField;
